import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { civilData } from '../../data/departmentalData/civil';

const Civil = () => {
  return <TemplatePage data={civilData} />;
};

export default Civil;
